<template>
    <div class="background-color-picker-container">
        <div v-for="(color, index) in colors"
             :key="index"
             class="color-container"
             :class="{'--active': color == $store.state.UI.backgroundColor}"
             :style="{ 'background-color': color }"
             @click="change(color)"
        ></div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    data() {
        return {
            colors: [
                '#000000',
                '#191919',
                '#333333'
            ]
        }
    },

    mounted() {
        let color = Cookies.get('BackgroundColor');
        if (color) this.$store.commit('UI/SET_BACKGROUND_COLOR', color);
    },

    methods: {
        change(color) {
            Cookies.set('BackgroundColor', color);
            this.$store.commit('UI/SET_BACKGROUND_COLOR', color);
        }
    }
}
</script>

<style lang="scss" scoped>
.background-color-picker-container {
    display: flex;
    gap: 5px;
    .color-container {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid var(--font-default-color);
        cursor: pointer;

        &.--active {
            border-color: white;
        }
    }
}
</style>
